import React, { useState } from "react";
import styles from "./Expenses.module.css";
import { FiEdit2 } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import Dropdown from "../../components/Dropdown/Dropdown";
import SearchBar from "../../components/SearchBar/SearchBar";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import IconAndName from "../../components/IconAndName/IconAndName";
import { MdOutlineTextSnippet } from "react-icons/md";
import CopyRight from "../../components/CopyRight/CopyRight";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import Action from "../../components/Action/Action";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const data = [
  {
    _id: "s1",
    studentName: "John Jacob",
    createdOn: "30/05/2025",
    createdBy: "Darshan Sir",
    expense: 2400,
  },
  {
    _id: "s2",
    studentName: "Jane Smith",
    createdOn: "29/05/2025",
    createdBy: "Darshan Sir",
    expense: 1800,
  },
  // more entries...
];

const handleDownloadExcel = () => {
  const formattedData = data.map((item) => ({
    "Register Name": item.studentName || "-",
    "Created On": item.createdOn || "-",
    "Created By": item.createdBy || "-",
    Expense: `INR ${item.expense || 0}`,
  }));

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Expenses");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(blob, "Expenses.xlsx");
};

  
  
const Expenses = () => {
  const dispatch = useDispatch();
  const [count, setCount] = useState(7);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
const [selectedDate, setSelectedDate] = useState("");
  const handlecreateform = () => {
    dispatch(openModal("addRegister"));
  };
  const handleEditClick = () => {
    dispatch(openModal("chooseRange"));
  };
  const totalExpense = data.reduce((sum, s) => sum + (s.expense || 0), 0);

  

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Registers", accessor: "studentName" },
    { title: "Created On", accessor: "createdOn" },
    { title: "Created By", accessor: "createdBy" },
    { title: "Expense", accessor: "expense" },
    { title: "Action", accessor: "action" },
  ];
  
  
  const ActionsData = [
    {
      label: "Send Invite",
      onclick: () => {
        console.log("send invite");
      },
    },
    {
      label: "Update Rooms",
      onclick: () => {
        dispatch(openModal("updateRoom"));
      },
    },
    {
      label: "Update Status",
      onclick: () => {
        dispatch(openModal("statusUpdate"));
      },
    },
    {
      label: "Update Groups",
      onclick: () => {
        dispatch(openModal("updateGroups"));
      },
    },
    {
      label: "Transfer Student",
      onclick: () => {
        dispatch(openModal("TransferStudent"));
      },
    },
    {
      label: "Create Folder",
      onclick: () => {
        dispatch(openModal("createFolder"));
      },
    },
  ];
  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        studentName: <LogoWithName name={item.studentName || "-"} />,
        createdOn: item.createdOn || "30/05/2025",
        createdBy: item.createdBy || "Darshan Sir",
        expense: item.expense != null ? `INR ${item.expense}` : "-",
        action: (
          <Action
            key={item._id}
            options={["Edit", "Delete"]}
            onSelect={(opt) => {
              console.log(`Selected "${opt}" for ${item.studentName}`);
              if (opt === "Edit") {
                dispatch(openModal("editDetails"));
              } else if (opt === "Delete") {
                dispatch(openModal("delete"));
              }
            }}
          />
        ),
      };
    });
  };
  
  

  const displayData = getColumnData(data);

  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.totalDisplay}>
              Total :{" "}
              <span className={styles.totalAmount}>INR {totalExpense}</span>
            </div>
            <button
              className={styles.downloadBtn}
              onClick={handleDownloadExcel}
            >
              Download Excel
            </button>

            <div className={styles.createForm}>
              <IconAndName
                icon={<MdOutlineTextSnippet />}
                title="Add Register"
                bgColor="Primary_Color"
                onClick={handlecreateform}
              />
            </div>
          </div>
          {/* 🟩 Result Cards + This Month */}

          {/* 🔍 Search & Filters Row */}
          <div className={styles.totalstudentcard}>
            <div className={styles.filters}>
              <CalendarInput
                label="Date"
                value={selectedDate}
                onChange={setSelectedDate}
                background="var(--Utility_Color1)"
                textColor="gray"
                iconColor="gray"
                placeholderColor="gray"
                borderRadius="25px"
                shadow={false}
              />
            </div>

            {/* Student Data Table */}
            <div className={styles.dynamicdata}>
              <DynamicTable
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </>
  );
};

export default Expenses;
